import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useApiCaller } from '../utils/ApiUtilities';
import { useError } from './ErrorContext';
import { getResetPasswordUrl } from '../utils/UrlUtilities';
import { constructResetPasswordPayload } from '../utils/PayloadUtils';

const isPasswordValid = (p) =>
    new RegExp(`^(?=.*[A-Z])(?=.*\\d)(?=.*[!@#$%^&*()_+\\-=[\\]{};:'",.<>/?]).{8,}$`).test(p);

export default function ResetPassword() {
    const CallApi = useApiCaller();
    const { showSuccess } = useError();
    const navigate = useNavigate();
    const [params] = useSearchParams();
    const token = params.get('token') || '';

    const [newPassword, setNewPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [busy, setBusy] = useState(false);

    const canSubmit = token && isPasswordValid(newPassword) && newPassword === confirm;

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!canSubmit) return;
        setBusy(true);
        const res = await CallApi({
            url: getResetPasswordUrl(),
            method: 'POST',
            payload: constructResetPasswordPayload(token, newPassword),
            token: false,
        });
        setBusy(false);
        if (res.success) {
            showSuccess('Password reset. Please log in with your new password.');
            navigate('/login');
        }
    };

    if (!token) {
        return (
            <div className="container mt-5" style={{ maxWidth: 420 }}>
                <div className="alert alert-danger">This reset link is invalid or incomplete.</div>
                <Link to="/forgot-password">Request a new link</Link>
            </div>
        );
    }

    return (
        <div className="container mt-5" style={{ maxWidth: 420 }}>
            <h2 className="mb-4">Set a new password</h2>
            <form onSubmit={handleSubmit}>
                <div className="mb-3">
                    <label>New password</label>
                    <input
                        type="password"
                        className={`form-control ${newPassword && !isPasswordValid(newPassword) ? 'is-invalid' : ''}`}
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        required
                    />
                    {newPassword && !isPasswordValid(newPassword) && (
                        <div className="invalid-feedback">Min 8 chars, with uppercase, digit, and special character.</div>
                    )}
                </div>
                <div className="mb-3">
                    <label>Confirm new password</label>
                    <input
                        type="password"
                        className={`form-control ${confirm && confirm !== newPassword ? 'is-invalid' : ''}`}
                        value={confirm}
                        onChange={(e) => setConfirm(e.target.value)}
                        required
                    />
                    {confirm && confirm !== newPassword && (
                        <div className="invalid-feedback">Passwords do not match.</div>
                    )}
                </div>
                <button type="submit" className="btn btn-primary w-100" disabled={busy || !canSubmit}>
                    {busy ? 'Resetting…' : 'Reset password'}
                </button>
            </form>
        </div>
    );
}
